module.exports = __webpack_public_path__ + "img/1f5dd.00b60ad.svg";